/* Fabrikone dispatch estimate v2. Dates are dispatch dates, not delivery promises. */
(() => {
  const DAY=86400000;
  const dateKey=day=>new Date(day*DAY).toISOString().slice(0,10);
  function parseDay(value){
    if(!/^\d{4}-\d{2}-\d{2}$/.test(value||''))return null;
    const day=Date.parse(value+'T00:00:00Z')/DAY;
    return Number.isInteger(day)&&dateKey(day)===value?day:null;
  }
  function calculate(now,config){
    const parts=Object.fromEntries(new Intl.DateTimeFormat('en-CA',{timeZone:config.timeZone||'Europe/Istanbul',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(now).map(p=>[p.type,p.value]));
    const today=parseDay(parts.year+'-'+parts.month+'-'+parts.day);
    const minute=Number(parts.hour)*60+Number(parts.minute)+Number(parts.second)/60;
    const cutoff=Number(config.cutoffHour)*60+Number(config.cutoffMinute);
    const holidays=new Set((config.holidays||'').split(/[\s,;]+/).filter(v=>parseDay(v)!==null));
    const working=day=>{
      const weekday=new Date(day*DAY).getUTCDay();
      return !holidays.has(dateKey(day))&&(weekday===0?config.sunday===true:weekday===6?config.saturday===true:true);
    };
    function nextWorking(day){for(let i=0;i<1096;i++,day++)if(working(day))return day;return null;}
    let dispatch=nextWorking(today+(minute>=cutoff?1:0));
    if(dispatch===null)return null;
    const processingDay=dispatch;
    const fixed=parseDay(config.fixedDate);
    const lead=Math.min(365,Math.max(0,Math.trunc(Number(config.leadDays)||0)));
    if(fixed!==null){
      // A forgotten past release date must never turn into a same-day claim.
      if(fixed<today)return null;
      dispatch=nextWorking(Math.max(dispatch,fixed));
    }else if(config.dayType==='Takvim günü'){
      dispatch=nextWorking(dispatch+lead);
    }else{
      for(let i=0;i<lead;i++){dispatch=nextWorking(dispatch+1);if(dispatch===null)return null;}
    }
    if(dispatch===null)return null;
    // Lead-time products use the next processing cutoff; a fixed dispatch date
    // uses that date's cutoff so it does not create an artificial earlier deadline.
    const deadlineDay=fixed!==null?dispatch:processingDay;
    return {date:dateKey(dispatch),offset:dispatch-today,minutesRemaining:Math.max(1,Math.ceil((deadlineDay-today)*1440+cutoff-minute))};
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={calculate,parseDay};return;}
  if(customElements.get('fab-dispatch-estimate'))return;
  customElements.define('fab-dispatch-estimate',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();clearTimeout(this.timer);
      this.controller=new AbortController();
      this.dataset.dispatchVersion='2026-09-06-countdown-2';
      try{this.config=JSON.parse(this.querySelector('[data-dispatch-config]').textContent);}catch{return;}
      this.variant=this.config.initialVariant;
      const signal=this.controller.signal;
      const changed=event=>{
        const info=this.closest('product-info');
        const id=event?.detail?.variant?.id||info?.querySelector('.buy-buttons-block input[name="id"]')?.value;
        if(id&&this.config.variants[String(id)])this.variant=id;
        this.update();
      };
      document.addEventListener('variant:update',changed,{signal});
      document.addEventListener('product:updated',changed,{signal});
      this.closest('product-info')?.addEventListener('change',()=>queueMicrotask(()=>changed()),{signal});
      document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.update();},{signal});
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,event=>{
        if(event.data?.sectionId===this.closest('product-info')?.dataset.section)changed({detail:{variant:event.data.variant}});
      });
      this.schedule();
      this.update();
    }
    schedule(){this.timer=setTimeout(()=>{if(!document.hidden)this.update();this.schedule();},60000-Date.now()%60000+25);}
    disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.unsubscribe?.();}
    update(){
      const config=this.config,variant=config.variants[String(this.variant)];
      const hasPreparation=Number(config.leadDays)>0||Boolean(config.fixedDate);
      if(!variant?.available||(variant.tracked&&variant.quantity<=0&&!hasPreparation)){this.hidden=true;return;}
      const result=calculate(new Date(),config);
      if(!result){this.hidden=true;return;}
      const labels=config.labels;
      let message;
      if(result.offset===0){message=labels.today;}
      else if(result.offset===1){message=labels.tomorrow;}
      else{
        const date=new Intl.DateTimeFormat(document.documentElement.lang||'tr',{day:'numeric',month:'long',weekday:'long',timeZone:'UTC'}).format(new Date(result.date+'T00:00:00Z'));
        message=labels.onDate.replace('__DATE__',date);
      }
      const hours=Math.floor(result.minutesRemaining/60),minutes=result.minutesRemaining%60;
      const time=[hours?hours+' '+labels.hours:'',minutes?minutes+' '+labels.minutes:''].filter(Boolean).join(' ');
      message=labels.countdown.replace('__TIME__',time)+' '+message;
      const label=this.querySelector('[data-dispatch-message]');
      if(label.textContent!==message)label.textContent=message;
      this.hidden=false;
    }
  });
})();
